import { defineComponent } from "vue";
import OptionBaseControl from "@/library/templates/default/controls/OptionBaseControl";
export default defineComponent({
  name: "RadioButtonListSection",
  extends: OptionBaseControl,
  methods: {
    doesSectionExist(optionId: string) {
      let sectionId = this.getOptionSectionId(optionId);
      return this.mtdt.Tree && this.mtdt.Tree[sectionId] ? true : false;
    },
    getOptionSection(optionId: string) {
      let sectionId = this.getOptionSectionId(optionId);
      let optionSelection = {} as { [key: string]: any };
      if (this.mtdt.Tree && this.mtdt.Tree[sectionId]) {
        optionSelection[sectionId as string] = this.mtdt.Tree[sectionId];
        optionSelection[sectionId as string].Classes = " radio-option-section";
      }
      return optionSelection;
    },
    reset(silent: boolean = true) {
      this.setValue(this.defaultState.value ? this.defaultState.value : null, silent);
      this.config.editedParentRowNumber = null;
      this.resetErrors();
      this.handleSectionToggle(this.defaultState.value as string, true);
    },
  },
  mounted() {
    this.handleSectionToggle(this.state.value, true);
  },
});
